export const isLoggedIn = function(state) {
  return state.auth.user.id !== null &&
         state.auth.user.id !== ''
}

export const user = function(state) {
  return state.auth.user
}

export const userName = function(state) {
  return state.auth.user.display_name
}

export const userId = function(state) {
  return state.auth.user.id
}

export const userPlan = function(state) {
  return state.auth.plan
}

export const userProducts = function(state) {
  return state.auth.products
}

export const userProductAccess = function(state) {
  return state.auth.user.productAccess
}

export const userPreferences = function(state) {
  return state.auth.user.preferences
}

export const userTimezone = function(state) {
  return state.auth.user.timezone
}

export const userUtilities = function(state) {
  return state.auth.utilities || []
}

export const userShares = function(state) {
  return state.auth.shares || []
}

export const regStatus = function(state) {
  return state.registered
}

export const isImpersonating = function(state) {
  return state.auth.user.impersonating
}

export const view = function(state) {
  return state.view
}

export const navStatus = function(state) {
  return state.nav.visible
}

export const savedPricingRequestUtilities = function(state) {
  return state.auth.userInputUtilities
}

export const savedPricingRequestIds = function(state) {
  return state.auth.userInputIds
}

export const savedPricingRequests = function(state) {
  return state.savedPricingRequests
}

// Get the current data request's "user inputs".
export const currentPricingRequest = function(state) {
  return state.currentPricingRequest
}

// Get the actual current data request.
export const currentDataRequest = function(state, getters) {
  const currentUserInputs = getters.currentPricingRequest

  return getters.savedPricingRequests.find(pricingRequest => pricingRequest.id === currentUserInputs.savedPricingRequestId)
}

export const lastLoadedPricingRequest = function(state) {
  return state.lastLoadedPricingRequest
}

export const currentPricingChartLockedDate = function(state) {
  return state.currentPricingChartLockedDate
}

export const utility = function(state) {
  return state.currentPricingRequest.utilityMeta
}

export const utilityId = function(state) {
  return state.currentPricingRequest.utilityMeta.id
}

export const utilityPlan = function(state) {
  return state.currentPricingRequest.utility.plan
}

export const planConfig = function(state) {
  return state.planConfig
}

export const customFacilityProfileColumns = function(state) {
  return state.customFacilityProfileColumns
}

export const facilityProfiles = function(state) {
  return state.facilityProfiles
}

export const facilityCategory = function(state) {
  return state.currentFacilityCategory
}

export const inlineFacilityPath = function(state) {
  return state.inlineFacilityPath
}

export const facilityType = function(state) {
  return state.currentPricingRequest.facilityType
}

export const facilityProfileName = function(state) {
  return state.currentPricingRequest.facilityProfileName
}

export const customFacilityProfileCategory = function(state) {
  return state.currentPricingRequest.customFacilityProfileCategory
}

export const facilityCheckboxSelections = function(state) {
  return state.currentPricingRequest.facilityCheckboxSelections
}

export const customFacilityProfile = function(state) {
  return state.currentPricingRequest.customFacilityProfile
}

export const customFacilityProfileComplete = function(state) {
  let customFacilityProfile = state.currentPricingRequest.customFacilityProfile

  if (Object.keys(customFacilityProfile).length > 0) {

    if (customFacilityProfile.months) {
      for (let i = 0; i < customFacilityProfile.months.length; ++i) {

        // Disabled if any profile fields are empty
        if (isNaN(customFacilityProfile.months[i].usage) || !customFacilityProfile.months[i].usage || customFacilityProfile.months[i].usage && customFacilityProfile.months[i].usage.length === 0) {
          return false

        } else if (customFacilityProfile.months[i].usage > 0) {

          if (isNaN(customFacilityProfile.months[i].onPeakUsage) || customFacilityProfile.months[i].onPeakUsage === '') {
            return false
          }

          if (!customFacilityProfile.months[i].peakDemand || customFacilityProfile.months[i].peakDemand && customFacilityProfile.months[i].peakDemand.length < 1) {
            return false
          }
        }
      }
    }

    if (customFacilityProfile.extraColumns.length === 0) {
      return true

    } else {
      // Disabled if any extra column fields are empty
      for (let i = 0; i < customFacilityProfile.extraColumns.length; ++i) {
        for (let x = 0; x < customFacilityProfile.extraColumns[i].months.length; ++x) {

          if (customFacilityProfile.extraColumns[i].months[x].value === 0) {
            continue
          }

          if (!customFacilityProfile.extraColumns[i].months[x].value) {
            return false
          }
        }
      }
      return true
    }
  } else {
    return true
  }
}

export const tempCustomFacilityProfile = function(state) {
  return state.tempCustomFacilityProfile
}

export const customFacilityProfileUiStep = function(state) {
  return state.customFacilityProfileUiStep
}

export const customFacilityProfileView = function(state) {
  return state.customFacilityProfileView
}

export const collapseCustomFacilityProfileTable = function(state) {
  return state.collapseCustomFacilityProfileTable
}

export const pricingRequestVolume = function(state) {
  return state.currentPricingRequest.volume
}

export const customFacilityVolume = function(state) {
  return state.currentPricingRequest.customFacilityVolume
}

export const startMonth = function(state) {
  return state.currentPricingRequest.startMonth
}

export const termLength = function(state) {
  return state.currentPricingRequest.termLength
}

export const notification = function(state) {
  return state.notification
}

export const allowPricingRequestSubmission = function(state) {
  return state.allowPricingRequestSubmission
}

export const declineBrokerFee = function(state) {
  return state.declineBrokerFee
}

export const submitPricingRequestHover = function(state) {
  return state.submitPricingRequestHover
}

export const isLoadingSavedPriceRequests = function(state) {
  return state.isLoadingSavedPriceRequests
}

export const dashboardSortUtility = function(state) {
  return state.dashboardSortUtility
}

export const dashboardPricingComponents = function(state) {
  return state.dashboardPricingComponents
}

export const pricingRequestStatus = function(state) {
  return state.pricingRequestStatus
}

export const currentPricingData = function(state) {
  return state.currentPricingData.data
}

export const currentPricingDataTotals = function(state) {
  return state.currentPricingData.totals
}

export const currentPricingDataRequestId = function(state) {
  return state.currentPricingData.requestId
}

export const currentPricingChartData = function(state) {
  return state.currentPricingChartData
}

export const expandAllPricingRows = function(state) {
  return state.expandAllPricingRows
}

export const batchDatesTotal = function(state) {
  return state.batchDatesTotal
}

export const batchDatesRemaining = function(state) {
  return state.batchDatesRemaining
}

export const currentBatch = function(state) {
  return state.currentBatch
}

export const acceptTermsOfUse = function(state) {
  return state.acceptTermsOfUse
}

export const shouldApplyUserBrandingToApp = function(state) {
  return state.userBranding.appliesTo.app
}

export const shouldApplyUserBrandingToProduct = function(state) {
  return state.userBranding.appliesTo.product
}

export const userBranding = function(state) {
  return state.userBranding
}
